import { TurnoverNoticePopup } from './TurnoverNoticePopup.jsx';
import {
  DEPOSIT_UNAVAILABLE_CLOSE_LABEL,
  DEPOSIT_UNAVAILABLE_MESSAGE,
  fetchDepositAvailability,
} from './helpers.js';

/**
 * Factory so the gate uses the same React copy as ninet6-app.js (inlined).
 * Binding useState from node_modules while the tree is reconciled by the
 * bundled copy leaves the dispatcher null and crashes on useState.
 */
export function createDepositAvailabilityGate({ useState, useEffect, createElement }) {
  function DepositAvailabilityGate({ children, navigateHome }) {
    const [ready, setReady] = useState(false);
    const [available, setAvailable] = useState(false);

    useEffect(() => {
      let cancelled = false;
      fetchDepositAvailability()
        .then((result) => {
          if (cancelled) return;
          setAvailable(result.depositAvailable === true);
          setReady(true);
        })
        .catch(() => {
          if (cancelled) return;
          setAvailable(false);
          setReady(true);
        });
      return () => {
        cancelled = true;
      };
    }, []);

    if (!ready) {
      return null;
    }

    if (available !== true) {
      return createElement(TurnoverNoticePopup, {
        message: DEPOSIT_UNAVAILABLE_MESSAGE,
        closeLabel: DEPOSIT_UNAVAILABLE_CLOSE_LABEL,
        onClose: () => {
          if (typeof navigateHome === 'function') {
            navigateHome();
            return;
          }
          if (typeof window !== 'undefined') {
            window.location.assign('/');
          }
        },
      });
    }

    return children || null;
  }

  return DepositAvailabilityGate;
}
